/* Keeps every video muted, inline, looping and playing. Mobile browsers (iOS in particular) only
   autoplay muted + playsinline video, and pause it when Low Power Mode, off-screen or tab changes hit. */
(function () {
  function prep(v) {
    v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('controls'); v.controls = false; v.disablePictureInPicture = true;
    if (v.preload === 'none') v.preload = 'auto';
  }
  function play(v) {
    prep(v);
    if (!v.paused && !v.ended) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* retried on first touch / scroll */ });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) play(e.target); });
  }, { rootMargin: '200px' }) : null;
  function scan() {
    document.querySelectorAll('video').forEach(function (v) {
      if (v.dataset.wfAuto) return;
      v.dataset.wfAuto = '1'; prep(v);
      v.addEventListener('pause', function () { if (!v.ended && document.visibilityState === 'visible' && v.dataset.wfUserOff !== '1') setTimeout(function () { play(v); }, 150); });
      v.addEventListener('stalled', function () { v.load(); play(v); });
      v.addEventListener('loadedmetadata', function () { play(v); });
      if (io) io.observe(v); else play(v);
    });
  }
  function kick() { document.querySelectorAll('video').forEach(play); }
  ['touchstart', 'touchend', 'pointerdown', 'scroll', 'click'].forEach(function (t) {
    window.addEventListener(t, kick, { once: true, passive: true });
  });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') kick(); });
  window.addEventListener('pageshow', kick);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
